import { render } from "./BigButton.vue?vue&type=template&id=47833261"
import script from "./BigButton.vue?vue&type=script&lang=js"
export * from "./BigButton.vue?vue&type=script&lang=js"

import "./BigButton.vue?vue&type=style&index=0&id=47833261&lang=scss"

import exportComponent from "/Users/silaskoehler/sublimes/bibelzentrum-herz-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__